export function matchesRoutePermission(route: string, permissionList?: string[] | null, allAllowed = false): boolean {
  if (allAllowed) return true
  if (!permissionList || permissionList.length === 0) return true

  const normalizedRoute = route.replace(/\/$/, '')

  return permissionList.some((permission) => {
    const normalizedPermission = permission.replace(/\/$/, '')
    return normalizedRoute === normalizedPermission || normalizedRoute.startsWith(`${normalizedPermission}/`)
  })
}
